import { Currency } from '@pulsex/sdk'
import { ChainId, pulsechain } from '@pulsex/chains'
import { TokenAddressMap } from '@pulsex/token-lists'
import { Address, getAddress } from 'viem'
import memoize from 'lodash/memoize'
import { BASE_PULSECHAIN_SCAN_URLS } from '../config'
import { chains } from './wagmi'

// returns the checksummed address if the address is valid, otherwise returns undefined
export const safeGetAddress = memoize((value: any): Address | undefined => {
  try {
    let value_ = value
    if (typeof value === 'string' && !value.startsWith('0x')) {
      value_ = `0x${value}`
    }
    return getAddress(value_)
  } catch {
    return undefined
  }
})

export function getBlockExplorerLink(
  data: string | number | undefined | null,
  type: 'transaction' | 'token' | 'address' | 'block' | 'countdown',
  chainIdOverride?: number,
): string {
  const chainId = chainIdOverride || ChainId.PULSECHAIN
  const chain = chains.find((c) => c.id === chainId)
  if (!chain) return pulsechain.blockExplorers.default.url
  switch (type) {
    case 'transaction': {
      return `${BASE_PULSECHAIN_SCAN_URLS[chainId]}/tx/${data}`
    }
    case 'token': {
      return `${BASE_PULSECHAIN_SCAN_URLS[chainId]}/token/${data}`
    }
    case 'block': {
      return `${BASE_PULSECHAIN_SCAN_URLS[chainId]}/block/${data}`
    }
    case 'countdown': {
      return `${BASE_PULSECHAIN_SCAN_URLS[chainId]}/block/countdown/${data}`
    }
    default: {
      return `${BASE_PULSECHAIN_SCAN_URLS[chainId]}/address/${data}`
    }
  }
}

export function getBlockExploreName(chainIdOverride?: number) {
  const chainId = chainIdOverride || ChainId.PULSECHAIN
  const chain = chains.find((c) => c.id === chainId)

  return chain?.blockExplorers?.default.name || pulsechain.blockExplorers.default.name
}

export function getPulseScanLinkForNft(
  collectionAddress: string,
  tokenId: string,
  chainId: ChainId = ChainId.PULSECHAIN,
): string {
  return `${BASE_PULSECHAIN_SCAN_URLS[chainId]}/token/${collectionAddress}?a=${tokenId}`
}

// add 100%
export function calculateGasMargin(value: bigint, margin = 10000n): bigint {
  return (value * (10000n + margin)) / 10000n
}

export function escapeRegExp(string: string): string {
  return string.replace(/[.*+?^${}()|[\]\\]/g, '\\$&') // $& means the whole matched string
}

export function isTokenOnList(defaultTokens: TokenAddressMap<ChainId>, currency?: Currency): boolean {
  if (currency?.isNative) return true
  return Boolean(currency?.isToken && defaultTokens[currency.chainId]?.[currency.address])
}
